module.exports = __webpack_public_path__ + "static/media/route-plus-self.6e1ab507.png";